<template>
  <div class="delivery-dispatch">
    <MainBackButton :forceHome="true" />
    <DeliveryHistoryModal />
    <p class="title is-4 has-text-info has-text-left" style="padding-top: 15px; margin-bottom:2px">
      <span style="padding-left:55px">Setup Delivery</span>
      <span class="is-pulled-right" style="margin-right:12px; margin-top:-5px">
        <span
          class="button is-success is-outlined"
          style="height:32px; margin-right:4px; padding:4px"
          @click="goToBatch"
        >Batch</span>
        <span class="button icon is-medium is-info is-outlined" @click="openDeliveryHistory">
          <i class="fa fa-list-ol" />
        </span>
      </span>
    </p>
    <div class="container">
      <div class="notification">
        <!-- Create Delivery -->
        <div class="field" v-if="!isInvalidForm">
          <div class="control">
            <button
              class="button is-danger is-fullwidth is-rounded"
              @click="confirmDelivery"
            >Create Delivery</button>
          </div>
        </div>
        <!-- Completed Reset -->
        <div class="field" v-if="completed">
          <div class="control">
            <button
              class="button is-success is-fullwidth is-rounded"
              @click="resetDelivery"
            >New Delivery</button>
          </div>
        </div>
        <!-- Pickup (restaurant / business address by default) -->
        <div class="field tags has-addons" v-if="businessName">
          <span class="single-line no-scrollbar" style="padding-bottom:10px">
            <span class="tag is-info is-medium">
              <i class="fa fa-store-alt" />
              &nbsp;{{ businessType }}
            </span>
            <span class="tag is-white is-medium has-text-link">
              <a :href="businessMap" target="_blank">{{ businessName }}</a>&nbsp;
            </span>
          </span>
        </div>

        <div class="field tags has-addons" v-if="driverID !== ''">
          <span class="single-line" style="padding-bottom:10px">
            <span class="tag is-medium" @click="clearDriver" style="background-color: orange">
              <i class="fa fa-shuttle-van" />
              <button class="delete" />&nbsp;
            </span>
            <span class="tag is-white is-medium">{{ driverName }}</span>
          </span>
        </div>

        <!-- Driver -->
        <div class="field" v-if="driverID === ''">
          <label class="label">Driver</label>
          <div class="control has-icons-left">
            <input
              class="input is-info"
              type="text"
              :value="driverName"
              @focus="clearDriver"
              placeholder="Name or mobile"
              @keyup="lookupDrivers($event)"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-shuttle-van"></i>
            </span>
          </div>
          <div class="list" v-if="drivers.length > 0">
            <span
              v-for="d in drivers"
              class="list-item"
              :key="d.key"
              @click="selectDriver(d)"
            >{{ d.key }}</span>
          </div>
        </div>

        <!-- ----------------- -->

        <!-- <div class="field tags has-addons" v-if="dropoffName">
          <span class="tag is-primary is-medium">
            <i class="fa fa-map-marker-alt" />&nbsp;
            <span>Dropoff</span>
          </span>
          <span class="tag is-white is-medium">
            <a :href="dropoffMap">{{ dropoffName }}</a>
            &nbsp;
            <button class="delete" @click="dropoff=null" />&nbsp;
          </span>
        </div>-->

        <!-- Based on pickup/dropoff should pre-fill cash and tukpay fields -->
        <!-- <div class="columns is-mobile">
          <div class="column" style="max-width:50vw">
            <div class="field">
              <label class="label">Date</label>
              <div class="control has-icons-left">
                <span class="icon is-small is-left">
                  <i class="fa fa-calendar-alt"></i>
                </span>
                <b-field type="is-warning">
                  <b-datepicker v-model="date" placeholder="Today" :min-date="today"></b-datepicker>
                </b-field>
              </div>
            </div>
          </div>
          <div class="column" style="max-width:50vw">
            <div class="field">
              <label class="label">Time</label>
              <div class="control has-icons-left">
                <span class="icon is-small is-left">
                  <i class="fas fa-clock" />
                </span>
                <b-field type="is-warning">
                  <b-timepicker v-model="time" placeholder="Now" hour-format="24"></b-timepicker>
                </b-field>
              </div>
            </div>
          </div>
        </div>-->

        <!-- Based on pickup/dropoff should pre-fill cash and tukpay fields -->
        <!-- <div class="columns is-mobile">
          <div class="column">
            <div class="field has-addons">
              <div class="control">
                <a class="button is-warning has-text-weight-medium">Cash</a>
              </div>
              <div class="control has-icons-left">
                <span class="icon is-small is-left">฿</span>
                <input class="input is-warning" v-model="cash" type="number" placeholder="0" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field has-addons">
              <div class="control">
                <a class="button is-warning has-text-weight-medium">TukPay</a>
              </div>
              <div class="control has-icons-left">
                <span class="icon is-small is-left">฿</span>
                <input class="input is-warning" v-model="tukpay" type="number" placeholder="0" />
              </div>
            </div>
          </div>
        </div>-->

        <div>
          <div class="field has-addons">
            <div class="control">
              <a class="button is-link has-text-weight-medium">
                <i v-if="true" class="fa fa-shuttle-van" />
                <i v-else class="fa fa-user" />
                &nbsp;฿{{ totalPrice }}
              </a>
            </div>
            <div class="control">
              <a class="button is-warning has-text-weight-medium">Cash</a>
            </div>
            <div class="control">
              <input class="input is-warning" v-model="cash" type="number" placeholder="฿" />
            </div>

            <div class="control">
              <a class="button is-warning has-text-weight-medium">TukPay</a>
            </div>
            <div class="control">
              <input class="input is-warning" v-model="tukpay" type="number" placeholder="฿" />
            </div>
          </div>
        </div>

        <div class="field has-addons" v-if="deliveries.length > 0" style="padding-top:2px">
          <div class="control has-text-weight-medium">
            <a class="button is-static">
              <i class="fa fa-user" />
              x{{deliveries.length}}
              Each ฿{{ eachFare.price }}
            </a>
          </div>
          <!-- <div class="control"></div> -->
          <div class="control">
            <a class="button is-static">Cash ฿{{ eachFare.cash }}</a>
          </div>
          <div class="control">
            <a class="button is-static">TukPay ฿{{ eachFare.tukpay }}</a>
          </div>
        </div>

        <div v-else style="height:8px" />

        <!-- Customer -->
        <div class="field" v-show="!newDelivery && !batch">
          <label class="label">
            Customer
            <span
              class="has-text-danger"
              style="font-size: 0.8em"
              v-if="isPhoneNumberPassenger"
            >(By Phone Number)</span>
          </label>
          <div class="control has-icons-left">
            <span class="icon is-small is-left">
              <i class="fas fa-user" />
            </span>
            <input
              class="input is-success"
              type="text"
              :value="passengerName"
              @focus="clearPassenger"
              placeholder="Name or mobile"
              @keyup="lookupPassengers($event)"
            />
          </div>
          <div class="list" v-if="isPhoneNumberPassenger" style="margin-bottom:0">
            <span class="list-item has-text-link" @click="selectPhoneNumberPassenger">
              Create Customer By Phone Number&nbsp;
              <i class="fa fa-check" />
            </span>
          </div>
          <div class="list" v-if="passengers.length > 0">
            <span
              v-for="p in passengers"
              class="list-item"
              :key="p.key"
              @click="selectPassenger(p)"
            >{{ p.key }}</span>
          </div>
        </div>

        <div v-if="showPrompt" style="padding-bottom:8px; margin-top:-5px;">
          <span class="tag is-warning has-text-link has-text-weight-semibold is-italic" @click>
            Add Another Dropoff ??&nbsp;
            <i class="fa fa-hand-point-up has-text-link" />
          </span>
        </div>

        <div class="field" v-if="newDelivery">
          <label class="label">Dropoff</label>
          <div class="control has-icons-left" @click="initGoogle">
            <span class="icon is-small is-left">
              <i class="fas fa-map-marker-alt" />
            </span>
            <input
              id="delivery-dispatch-google"
              class="input is-danger"
              type="text"
              ref="autocomplete"
              onfocus="value = ''"
              placeholder="Location"
            />
          </div>
        </div>

        <div v-if="deliveries.length > 0">
          <div style="height:1px; background-color:lightblue" />
          <div style="height:6px;" />
        </div>

        <!-- Dropoff (restaurant / business address by default) -->
        <div v-for="(d, idx) in dropoffs" :key="d.id" :id="d.id">
          <div class="field has-text-left delivery">
            <span class="single-line tags has-addons">
              <span class="tag is-dark is-medium" @click="deleteDelivery(idx)">
                <i class="fa fa-user" />&nbsp;
                <span>#{{ inverseIndex(idx) }}</span>
                <button class="delete" />&nbsp;
              </span>
              <span class="tag is-white is-medium">{{ customerName(d) }}</span>
            </span>
            <!-- <br /> -->
            <div style="height:1px" />
            <span class="single-line tags has-addons">
              <span class="tag is-warning is-medium" @click="addRef(idx)">
                <i class="fa fa-receipt" />&nbsp;
                <i v-if="ref(d)" class="has-text-weight-semibold">{{ d.ref }}</i>
                <i v-else class="fa fa-question" />
              </span>
              <span class="tag is-primary is-medium" v-if="dropoffName(d)">
                <i class="fa fa-flag-checkered" />
                <button class="delete" @click="deleteDropoff(idx)" />&nbsp;
              </span>
              <span class="tag is-white is-medium has-text-link" v-if="dropoffName(d)">
                <a @click="dropoffMap(d)">{{ dropoffName(d) }}</a>
              </span>
              <span class="tag is-danger is-medium" v-else @click="enterDropoff">
                <i class="fa fa-flag-checkered" />&nbsp;
                Dropoff&nbsp;
                <i class="fa fa-question" />&nbsp;
              </span>
            </span>
            <div style="height:1px; background-color:lightblue" />
            <div style="height:6px;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import $Scriptjs from "scriptjs";
import MainBackButton from "@/components/MainBackButton.vue";
import geo from "@/geo";
import DeliveryHistoryModal from "@/components/DeliveryHistoryModal.vue";

export default {
  name: "DeliveryDispatch",
  components: {
    DeliveryHistoryModal,
    MainBackButton
  },
  data() {
    return {
      workflows: ["Sii Lor", "Private Tuk Tuk", "Songthaew", "Public Tuk Tuk"],
      businesses: [],
      drivers: [],
      passengers: [],
      passengerName: "",
      selectedPassenger: null,
      driverName: "",
      selectedDriver: "",
      pickup: null,
      dropoff: null,
      workflowType: "",
      workflowID: "",
      businessID: "",
      passengerID: "",
      driverID: "",
      pickupURL: "",
      dropoffURL: "",
      cash: null,
      tukpay: null,
      time: null,
      date: null,
      deliveries: [],
      prompt: false,
      completed: false,
      z: 0, // hack to get dropoffs to update
      batch: false, // is it from batch?
      batchVehicle: null
    };
  },
  computed: {
    showPrompt() {
      return this.prompt;
    },
    totalPrice() {
      var cash = parseInt(this.cash || 0);
      var tukpay = parseInt(this.tukpay || 0);
      return cash + tukpay;
    },
    role() {
      return this.$store.getters.getDeliveryDispatcherRole;
    },
    workflow() {
      if (!this.role) return;
      return this.role.workflow;
    },
    deliveryWorkflowID() {
      if (!this.role) return null;
      return this.role.workflow_id;
    },
    business() {
      if (!this.role) return null;
      return this.role.business;
    },
    businessName() {
      if (this.business) return this.business.name;
      return null;
    },
    businessType() {
      if (this.business) return this.business.business_type;
      return null;
    },
    businessNameAndType() {
      return `${this.businessName} (${this.businessType})`;
    },
    businessMap() {
      if (!this.business) return null;
      var lat = this.business.lat;
      var lon = this.business.lon;
      return `http://www.google.com/maps/place/${lat},${lon}`;
    },
    eachFare() {
      //   console.log("# deliveries", this.deliveries.length);
      var fare = this.getHypotheticalFare();
      return fare;
    },
    newDelivery() {
      //   if (this.deliveries.length === 0) return false;
      //   var i = this.deliveries.length - 1; // last element
      //   console.log("check new delivery", this.deliveries[i]);
      //   if (this.deliveries[i].dropoff) return false; // dropoff is set so not new
      //   this.deliveries.forEach(d => {
      //     if (!d.dropoff) return true; // dropoff is empty so true
      //   });
      return this.deliveries.filter(d => !d.dropoff).length > 0;
      //   return false; //true;
    },
    dropoffs() {
      console.log("force update", this.z);
      return this.deliveries.slice().reverse();
    },
    today() {
      var now = new Date();
      return now;
      // var dt = new Date(now - 1000 * 60 * 60 * 24); // subtract a day
    },
    isPhoneNumberPassenger() {
      if (this.passengerID === "") return false;
      if (this.passengerID !== this.passengerName) return false;
      return true;
    },
    isInvalidForm() {
      if (this.completed) return true; // already completed
      if (this.deliveries.length === 0) return true;
      if (this.driverID === "") return true;
      //   if (!this.cash || !this.tukpay) return true;
      if (this.newDelivery) return true;
      return false;
    }
  },
  mounted() {
    $Scriptjs(
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places",
      () => this.initGoogle()
    );
  },
  activated() {
    this.pickup = {
      id: "special_stop",
      name: this.business.name, // this.businessNameAndType
      lat: this.business.lat,
      lon: this.business.lon
    };
    this.batchVehicle = this.$route.query.vehicle; // returns string not int
    if (this.batchVehicle) {
      this.clearDriver();
      this.batchVehicle = parseInt(this.batchVehicle); // if not null convert to int
      this.batch = true;
      this.setupBatchVehicle(this.batchVehicle);
      var vehiclesCompleted = this.$store.state.batchVehiclesCompleted;
      if (vehiclesCompleted.includes(this.batchVehicle)) this.completed = true;
      else this.completed = false;
    } else {
      this.batch = false;
    }
  },
  methods: {
    setupBatchVehicle(i) {
      console.log("setting up batch for vehicle: ", i);
      this.deliveries = this.$store.state.batchOrders.filter(
        o => o.vehicle == i
      );
      //   this.deliveries.push();
      //   this.deliveries.pop();
    },
    goToBatch() {
      this.$router.push("/batch").catch(err => {
        console.error("push_batch err:", err);
        location.reload();
      });
    },
    openDeliveryHistory() {
      this.displayModal(".delivery-history-modal");
      EventBus.$emit("DELIVERY_HISTORY", this.deliveryWorkflowID);
    },
    deleteDropoff(idx) {
      if (this.newDelivery) {
        this.$swal("Finish current dropoff first");
        return;
      }
      this.prompt = false;
      var i = this.revertIndex(idx);
      this.deliveries[i].dropoff = null;
    },
    ref(d) {
      return d.ref;
    },
    addRef(idx) {
      var i = this.revertIndex(idx);
      console.log("idx", idx, i);
      this.$swal({
        text: "Enter reference number",
        input: "number"
      }).then(val => {
        if (val.value) {
          this.deliveries[i].ref = val.value;
          this.z += 1; // hack
        }
      });
    },
    inverseIndex(idx) {
      return this.deliveries.length - idx; // print inverse in list
    },
    revertIndex(idx) {
      return this.inverseIndex(idx) - 1; // inverse it again
    },
    addDelivery(p) {
      var delivery = {
        passengerID: p.value,
        passengerName: p.key
      };
      this.deliveries.push(delivery);
    },
    deleteDelivery(idx) {
      var i = this.revertIndex(idx);
      this.$swal({
        title: "Delete this dropoff?",
        showCancelButton: true,
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("no")
      }).then(val => {
        if (val.value) {
          this.deliveries.splice(i, 1);
          this.passengers = []; // clear passengers
          this.clearPassenger();
        }
      });
    },
    setDropoff(stop, mapURL) {
      var d = this.deliveries.find(d => !d.dropoff);
      d.dropoff = stop;
      d.map = mapURL;
      //   var i = this.deliveries.length - 1; // index of last element
      //   this.deliveries[i].dropoff = stop;
      //   this.deliveries[i].map = mapURL;
      this.deliveries = JSON.parse(JSON.stringify(this.deliveries)); // force update
      this.clearPassenger();
      this.prompt = true;
    },
    selectPassenger(p) {
      this.passengerID = p.value;
      console.log("selectPassenger", p);
      this.passengerName = p.key;
      this.passengers = [];
      this.addDelivery(p);
    },
    selectPhoneNumberPassenger() {
      if (this.newDelivery) return;
      console.log("selectPhoneNumberPassenger", this.passengerName);
      if (this.passengerName.length < 8) {
        alert("Please enter a complete phone number 📞");
        return;
      }
      if (this.passengerName[0] === "0") {
        this.passengerName = `+66` + this.passengerName.substring(1);
      }
      var p = {
        value: this.passengerName,
        key: this.passengerName
      };
      this.addDelivery(p);
    },
    clearPassenger() {
      this.passengerName = "";
      this.passengerID = "";
      this.passengers = [];
      //   this.deliveries.pop();
    },
    selectDriver(d) {
      this.driverID = d.value;
      console.log("selectDriver", d);
      this.driverName = d.key;
      this.drivers = [];
    },
    clearDriver() {
      this.driverName = "";
      this.driverID = "";
    },
    // selectDriver(e) {
    //   this.driverID = e.target.value;
    //   console.log("selected driver", this.driverID, e);
    // },
    lookupPassengers(e) {
      this.prompt = false;
      var text = e.target.value;
      this.passengerName = text;
      console.log("lookupPassengers", text);
      if (text.length < 3) {
        this.passengers = [];
        return; // don't check until at least 3 letters long
      }
      if (text[0] === "+") {
        this.passengerID = text; // phone number can act as temporary passenger ID
        console.log("passengerID", text);
        return; // entering phone number don't look up users
      }
      if (text[0] === "0" && text.length > 5) {
        this.passengerID = text; // phone number can act as temporary passenger ID
        console.log("passengerID", text);
        return; // entering phone number don't look up users
      }
      this.$store
        .dispatch("autocompleteUsers", this.trim0(text))
        .then(res => {
          if (res.data) this.passengers = res.data;
          else this.passengers = [];
        })
        .catch(err => console.error("userAutocomplete", err));
    },
    lookupDrivers(e) {
      var text = e.target.value;
      this.driverName = text;
      console.log("lookupDrivers", text);
      if (text.length < 3) {
        this.drivers = [];
      } else {
        if (text[0] === "+") {
          this.driverID = text; // phone number can act as temporary passenger ID
          console.log("driverID", text);
          return; // entering phone number don't look up users
        }
        this.$store
          .dispatch("autocompleteDrivers", this.trim0(text))
          .then(res => {
            if (res.data) this.drivers = res.data;
            else this.drivers = [];
          })
          .catch(err => console.error("userAutocomplete", err));
      }
    },
    trim0(s) {
      if (s[0] === "0") return s.substring(1); // remove leading 0
      return s;
    },
    createStop(place) {
      return {
        id: "special_stop",
        name: place.name || place.formatted_address,
        lat: place.geometry.location.lat(),
        lon: place.geometry.location.lng()
      };
    },
    dropoffMap(d) {
      if (!d.dropoff) return null;
      window.location.href = d.map;
    },
    dropoffName(d) {
      if (!d.dropoff) return false;
      return d.dropoff.name;
    },
    customerName(d) {
      if (d.passengerName) return d.passengerName;
      return d.phone_number; // from batch
    },
    enterDropoff() {
      this.initGoogle();
      this.$refs.autocomplete.focus();
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: []
          // componentRestrictions: { country: "th" }
        }
      ); // uses all, options are ["address", "establishment", "geocode"]
      this.geolocate(); // Bias autocomplete to the user geolocation,

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        this.console(`selected google location: ${place.name}`, place);
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        this.url = place.url;
        this.place = place;
        var stop = this.createStop(place);
        this.setDropoff(stop, place.url);
        // if (!this.pickup) {
        //   this.pickup = stop;
        //   this.pickupURL = place.url;
        // } else {
        //   this.dropoff = stop;
        //   this.dropoffURL = place.url;
        // }
        document.getElementById("delivery-dispatch-google").focus();
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(position => {
        var coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        var circle = new google.maps.Circle({
          center: coords,
          radius: position.coords.accuracy
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    },
    getFare(n) {
      //   var n = this.deliveries.length; // split fare n ways for batch delivery
      if (!this.tukpay) this.tukpay = 0;
      if (!this.cash) this.cash = 0;
      var price = parseInt(this.tukpay) + parseInt(this.cash);
      var discount = parseInt(this.tukpay);
      return {
        version: "v1",
        price: parseInt(price / n),
        discount: parseInt(discount / n),
        cash: parseInt(this.cash / n),
        tukpay: parseInt(this.tukpay / n)
      };
    },
    getHypotheticalFare() {
      var n = this.deliveries.length; // split fare n ways for batch delivery
      var tukpay = this.tukpay;
      var cash = this.cash;
      if (!tukpay) tukpay = 0;
      if (!cash) cash = 0;
      var price = parseInt(tukpay) + parseInt(cash);
      var discount = parseInt(tukpay);
      return {
        version: "v1",
        price: parseInt(price / n),
        discount: parseInt(discount / n),
        cash: parseInt(cash / n),
        tukpay: parseInt(tukpay / n)
      };
    },
    parseScheduledTime() {
      if (!this.date) {
        return this.time.toISOString(); // time will always be set currently
      }
      // actually could let user not enter and default to NOW, not scheduled
      var dt = this.date;
      dt.setHours(this.time.getHours());
      dt.setMinutes(this.time.getMinutes());
      if (dt < new Date()) {
        alert("Scheduled time cannot be in the past!!");
        return null; // can't be in the past
      }
      return dt.toISOString();
    },
    confirmDelivery() {
      var fare = this.getFare(1);
      this.$swal({
        title: "Confirm Delivery",
        html: `Create <strong>${this.deliveries.length}</strong> Orders Now<br><br>
        Total Price: <strong>฿${fare.price}</strong>
        <br>Cash ฿${fare.cash} + TukPay ฿${fare.tukpay}`,
        showCancelButton: true,
        confirmButtonText: this.$t("okay"),
        cancelButtonText: this.$t("cancel")
      }).then(val => {
        if (val.value) this.createDelivery();
      });
    },
    createDelivery() {
      this.pickup = {
        id: "special_stop",
        name: this.business.name,
        lat: this.business.lat,
        lon: this.business.lon
      };
      var loader = this.loadingDots();
      this.deliveries.forEach((d, i) => {
        console.log(`createDelivery ${i}`, d);
        this.createTransaction(d);
      });
      setTimeout(() => loader.hide(), 2000);
      this.completed = true;
      if (this.batch) {
        this.$store.commit(
          "setBatchVehicleCompleted",
          parseInt(this.batchVehicle)
        );
      }
    },
    tripDistance(d) {
      var dist = geo.distanceToUserInMeters(this.pickup, d.dropoff);
      var drivingDist = Math.round(dist * 1.25); //
      this.console(`tripDistance ${dist} (${drivingDist})`);
      return drivingDist;
    },
    resetDelivery() {
      if (this.$route.query.vehicle) {
        this.$router.replace("delivery"); // clear query
      }
      location.reload(); // I think reload should be enough to reset
    },
    createTransaction(d) {
      var delivery = {
        type: this.businessType,
        business_name: this.businessName,
        workflow_id: this.deliveryWorkflowID
      };
      var obj = {
        type: "delivery",
        pickup_stop: this.pickup,
        dropoff_stop: d.dropoff,
        fare: this.getFare(this.deliveries.length), // split fare n ways
        ref: d.ref, // reference number
        delivery: delivery
        // notifications: "off" // this.workflow.data.notifications
      };
      obj.fare.distance = this.tripDistance(d);
      //   var loader = this.loadingDots();
      var customerID = d.passengerID; // will be null if batch
      if (!customerID) customerID = this.convertPhoneNumber(d.phone_number);
      this.$store
        .dispatch("createTransactionNoDebounce", {
          workflow_type_name: "Delivery", //role.workflowType, << set this based on the driverID?
          workflow_id: "", //role.workflowID, << set this based on the driverID?
          business_id: this.business.id, // restaurant business ID
          created_by: customerID, //d.passengerID,
          handled_by: this.driverID,
          data: obj
        })
        .then(() => {
          this.$swal({
            title: `Deliveries are on their way! Please confirm with the driver 🙌🏽`, //this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000
          });
        })
        .catch(err => this.apiError(err));
      // .finally(() => loader.hide());
    }
  }
};
</script>

<style scoped>
.notification {
  padding: 1rem;
}
label.label {
  margin-bottom: 0;
}
.column {
  padding-bottom: 0;
}
.tag {
  padding: 0 6px;
}
.tags {
  margin-bottom: 0;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
a.button {
  padding: 5px 5px;
}
</style>
